import { graphql } from '../../generated';

export const GET_FRONTEND_VERSION = graphql(`
  query GetFrontEndVersion {
    frontend {
      build
      lastUpdatedAt
    }
  }
`);
